import React from 'react';
import { FaAlignLeft, FaPlayCircle } from 'react-icons/fa';
import { StaticImage } from 'gatsby-plugin-image';
import {
  Flex,
  Box,
  Grid,
  GridItem,
  Heading,
  Text,
  Link,
} from '@chakra-ui/react';
import SectionTitle from '../../components/shared/SectionTitle';

interface CustomerItem {
  image: React.ReactNode;
  name: string;
  description: string;
  readLink: string;
  watchLink?: string;
}

const CUSTOMER_ITEMS: CustomerItem[] = [
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/endeavor-exteriors.webp"
        alt="Endeavor Exteriors"
      />
    ),
    name: 'Endeavor Exteriors',
    description:
      'Endeavor Exteriors empowering homeowners to take charge of their exterior remodeling project with HOVER Connect.',
    readLink:
      'https://hover.to/blog/endeavor-exteriors-leading-way-exterior-restoration-digital-sales-experience/',
    watchLink: 'https://hover.wistia.com/medias/46ka2li674',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/beldon.webp"
        alt="Beldon"
      />
    ),
    name: 'Beldon',
    description:
      'Beldon further raising the bar when it comes to customer experience with HOVER.',
    readLink:
      'https://hover.to/blog/beldon-successfully-launched-siding-business-hover/',
    watchLink: 'https://hover.wistia.com/medias/i2b6dcq113',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/rapid-roofing.webp"
        alt="Rapid Roofing"
      />
    ),
    name: 'Rapid Roofing',
    description:
      'Establishing trust, setting themselves apart and increasing their close rates from 30% to 75%. ',
    readLink: 'https://hover.to/blog/rapid-roofing-doubled-close-rate-hover/',
    watchLink: 'https://hover.wistia.com/medias/l6e752c5qa',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/benson-property.webp"
        alt="Benson Property"
      />
    ),
    name: 'Benson Property',
    description:
      'Saving time in the selling and production process, allowing them to restore damaged homes quicker. ',
    readLink:
      'https://hover.to/blog/benson-property-supporting-communities-restoring-homes-quicker/',
    watchLink: 'https://hover.wistia.com/medias/n3qgsl9owu',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/Timberland_Exteriors_Paul_Trautmann.webp"
        alt="Timberland Exteriors"
      />
    ),
    name: 'Timberland Exteriors',
    description:
      'Saving time and money with accurate measurements and selling more jobs by delivering quotes faster.',
    readLink: 'https://hover.to/blog/case-study-timberland-exteriors/',
    watchLink: 'https://hover.wistia.com/medias/9wqtjd2ukd',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/chattanooga.webp"
        alt="Chattanooga Exteriors"
      />
    ),
    name: 'Chattanooga Exteriors',
    description:
      '20 hours per week saved on measuring and establishing instant credibility, leading to a 15% increase in close rates. ',
    readLink: 'https://hover.to/blog/case-study-chattanooga-exteriors/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/craftsman.webp"
        alt="Craftsman’s Choice"
      />
    ),
    name: 'Craftsman’s Choice',
    description:
      'Removing human error and improving project communication to complete more jobs per year.',
    readLink: 'https://hover.to/blog/case-study-craftsmans-choice/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/kb.webp"
        alt="K&B Home Remodelers"
      />
    ),
    name: 'K&B Home Remodelers',
    description:
      'Growing business by more than 35%. Retaining all customers and attracting new ones through referrals.',
    readLink: 'https://hover.to/blog/case-study-k-b-home-remodelers/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/vanguard.webp"
        alt="Vanguard Home Design"
      />
    ),
    name: 'Vanguard Home Design',
    description:
      'Offering an engaging customer experience and establishing trust to close deals quickly.',
    readLink: 'https://hover.to/blog/case-study-vanguard-home-designs/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/Greiman-Construction-Services.jpeg"
        alt="Greiman Construction Services"
      />
    ),
    name: 'Greiman Construction Services',
    description:
      'Doubling revenue within one year by shortening the sales cycle and running 4 additional leads a day. ',
    readLink: 'https://hover.to/blog/case-study-greiman-construction-services/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/Carolina-Photo-1.jpeg"
        alt="Carolina Exteriors"
      />
    ),
    name: 'Carolina Exteriors',
    description:
      'Guaranteeing​ ​customer​ ​satisfaction​ ​on​ ​every​ ​job by visualizing the desired outcome and eliminating ambiguity.',
    readLink: 'https://hover.to/blog/carolina-exteriors-case-study/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/bachmans.webp"
        alt="Bachman’s Roofing, Building & Remodeling"
      />
    ),
    name: 'Bachman’s Roofing, Building & Remodeling',
    description:
      'Using the 3D model to create trust and credibility leading to more deals closed on the first visit.',
    readLink:
      'https://hover.to/blog/bachmans-roofing-building-remodeling-closes-deals-first-visit/',
  },
  {
    image: (
      <StaticImage
        placeholder="blurred"
        src="../../images/neighborhood.webp"
        alt="Neighborhood Restoration Company"
      />
    ),
    name: 'Neighborhood Restoration Company',
    description:
      'Returning more homes to their original condition by working more efficiently with HOVER Prospect.',
    readLink:
      'https://hover.to/blog/case-study-neighborhood-restoration-company-nrc/',
  },
];

const CustomerGrid = () => (
  <Box maxW="8xl" mx="auto" px="5" my="20">
    <SectionTitle title="These organizations trust HOVER to estimate, visualize and streamline their projects." />
    <Grid
      maxW="7xl"
      mx="auto"
      my="10"
      templateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(2, 1fr)',
        `repeat(${3}, 1fr)`,
      ]}
      justifyContent="center"
      columnGap={14}
      rowGap={14}
      px={[2, 9]}
    >
      {CUSTOMER_ITEMS.map(customerItem => (
        <GridItem key={customerItem.name} mx="5">
          {customerItem.image}
          <Heading my="5" as="h3">
            {customerItem.name}
          </Heading>
          <Text mb="5">{customerItem.description}</Text>
          <Flex alignItems="center">
            <Link
              href={customerItem.readLink}
              target="_blank"
              rel="noreferrer"
              fontWeight="bold"
              mr="7"
            >
              <Flex alignItems="center">
                <FaAlignLeft />
                <Text mx="3">READ</Text>
              </Flex>
            </Link>

            {customerItem.watchLink && (
              <Link
                href={customerItem.watchLink}
                target="_blank"
                rel="noreferrer"
                fontWeight="bold"
              >
                <Flex alignItems="center">
                  <FaPlayCircle />
                  <Text mx="3">WATCH</Text>
                </Flex>
              </Link>
            )}
          </Flex>
        </GridItem>
      ))}
    </Grid>
  </Box>
);

export default CustomerGrid;
